module.exports = __webpack_public_path__ + "static/media/icon-3.2a9a7b0f.svg";